export type CompanyView = 'grid' | 'list';
export const COMPANY_VIEW_KEY = 'ggb.companies-view';

export function readCompanyView(): CompanyView {
  try {
    return localStorage.getItem(COMPANY_VIEW_KEY) === 'list' ? 'list' : 'grid';
  } catch {
    return 'grid';
  }
}
export function writeCompanyView(view: CompanyView) {
  try {
    localStorage.setItem(COMPANY_VIEW_KEY, view);
  } catch {
    // The selected layout still applies for this visit when storage is unavailable.
  }
}
